import HotelOutlinedIcon from '@mui/icons-material/HotelOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import type { ModuleDefinition } from '../../../app/moduleRegistry';
import type { CurrentUser } from '../../../api/types/auth';
import CoperReservationsPage from './pages/CoperReservationsPage';

/**
 * "Coper Rezervasyonları" (Coper B2B) — SA-6. Firma + tarih aralığı →
 * `Hotel/ReservationList` → satır detayı `Hotel/ReservationLoad` + "Yeniden Export"
 * `Hotel/ReExportCoper`.
 *
 * (2026-09-08: "Cari Hesap Yönetimi" ekranı kullanıcı kararıyla kaldırıldı —
 * `Hotel/SearchCurrency` / `Hotel/NewCurrent` / `Hotel/GetCreditLimit` / `Coper/CoperAcentaList`
 * artık UI'da yok; bkz. `api/endpoints/_excluded.ts`.)
 *
 * Legacy MVC'de ayrı bir `CoperController` yoktu (`OtelController` vardı) — kapsam kullanıcı
 * kararıyla dahil; uçlar kod-izli `Docs/api/03-...md`'den, canlı doğrulanmadı. Master GSA'ya
 * özel, "Otel" grubunda (standalone modül — `app/modules.ts`'e ayrı satır olarak eklenir).
 */
const isVisible = (user: CurrentUser | null) => !!user?.isMasterGsa;

export const coperModule: ModuleDefinition = {
  routes: [{ path: 'hotel/coper/reservations', element: <CoperReservationsPage /> }],
  menuItems: [
    {
      label: 'Coper Rezervasyonları',
      path: 'hotel/coper/reservations',
      icon: <ReceiptLongOutlinedIcon />,
      group: 'Otel',
      groupIcon: <HotelOutlinedIcon />,
      isVisible,
    },
  ],
};
